import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // 나중에 디자인을 위해 필요함

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);